<template>
    <div class="form-group">
        <label for="select-carte-search">Rechercher une carte</label>
        <input id="select-carte-search" class="form-control" type="text" v-model="searchQuery" autocomplete="off" placeholder="saisir ici les termes recherchés puis sélectionner la carte désirée dans la liste">
        <ul id="select-carte"
            class="form-control"
            v-model="selectedCard"
            v-show="availableCards.length > 0"
            @change="$emit( 'change-selected', selectedCard)">
            <li v-for="card in availableCards" v-bind:value="{ id: card.id, name: card.name, desc: card.desc }"
                v-on:click="selectCard(card)">
                {{ card.name }}
            </li>
        </ul>
    </div>
</template>

<script>

  export default {

    name: 'SearchCard',

    data() {
      return {
        selectedCard: {},
        searchQuery: '',
        availableCards: []
      }
    },

    watch: {
      searchQuery: function () {
        if (this.searchQuery === '') {
          this.availableCards = {}
          return
        }
        window.Trello.get('search', {query: this.searchQuery, modelTypes: 'cards'}, this.getCards)
      }
    },

    methods: {

      getCards: function (data) {
        this.availableCards = []
        for (let i = 0; i < data.cards.length; i++) {
          this.availableCards.push(data.cards[i])
        }
      },

      selectCard: function (card) {
        this.selectedCard = card
        this.availableCards = []
        this.$emit('change-selected', this.selectedCard)
      }

    }

  }

</script>


<style>
    #select-carte {
        list-style-type: none;
        position: absolute;
        height: auto;
        max-width: 85vw;
        background-color: white;
        z-index: 1000;
    }

    #select-carte li {
        margin-bottom: 5px;
        cursor: pointer;
    }

    #select-carte li:hover {
      font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/AssociateSub/SearchCard.vue